import {FILES_INFO_RECEIVED} from '../store/actionTypes';

export function filesInfoReceived(files) {
    return {
        type: FILES_INFO_RECEIVED,
        files,
    };
}
